import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[ensureNegativeFront]',
})
export class EnsureNegativeFrontDirective {
    constructor(private ngControl: NgControl) {}
    @HostListener('keydown', ['$event'])
    onInput(event: KeyboardEvent): void {
        const inputElement = event.target as HTMLInputElement;

        if (event.key === '-' && inputElement.value.length !== 0) {
            inputElement.value = `-${inputElement.value}`;
            event.preventDefault();
        }

        if (this.ngControl && this.ngControl.control) {
            this.ngControl.control.setValue(inputElement.value);
        }
    }
}
